import { render, staticRenderFns } from "./MasterCardContactNumber.vue?vue&type=template&id=2bdf75b0&scoped=true"
import script from "./MasterCardContactNumber.vue?vue&type=script&lang=js"
export * from "./MasterCardContactNumber.vue?vue&type=script&lang=js"
import style0 from "./MasterCardContactNumber.vue?vue&type=style&index=0&id=2bdf75b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdf75b0",
  null
  
)

export default component.exports